import api from "@/apiConfig/api";
import apiV2 from "@/apiConfig/api-v2";
import { ElMessage } from "element-plus";
import { decryptText } from "@/utils/cryptFunc";

// Helper function to check if current user is academy role
const isAcademyRole = () => {
  const role = decryptText(localStorage.getItem("role"));
  return role === "academy";
};

export default {
  namespaced: true,
  state() {
    return {
      users: [],
      loading: false,
      addDialog: false,
      holidays: [],
      holidaysLoaded: false,
      isFetchingHolidays: false,
      holidayLoading: false,
      holidayDialog: false,
      addedEmployerId: null,
      addedHolidayId: null,
      deleteHolidayDialog: false,
      deletingHoliday: null,
      editEmployerDialog: false,
      editingEmployer: null,
      slots: [],
      userSlots: [],
      positions: [],
    };
  },
  actions: {
    async getUsers(ctx, role = null) {
      ctx.state.loading = true;
      try {
        const users = await apiV2
          .get("/users/all-users", {
            params: {
              role: role,
            },
          })
          .then((res) => res.data);

        ctx.state.users = users.sort((a, b) =>
          a?.first_name?.localeCompare(b?.first_name)
        );
      } catch (error) {
        ctx.state.users = [];
      } finally {
        ctx.state.loading = false;
      }
    },
    changeAddDialog(ctx) {
      ctx.state.addDialog = !ctx.state.addDialog;
    },
    async addUser(ctx, formData) {
      ctx.state.loading = true;
      await apiV2
        .post("/users/create", formData)
        .then((res) => {
          ctx.state.addedEmployerId = res.data.id;
          ctx.dispatch("getUsers");
          ctx.state.addDialog = false;
          ElMessage.success("Hodim muvaffaqiyatli qo'shildi!");
        })
        .catch((error) => {
          console.error("Error adding user:", error);
          ElMessage.error("Failed to add user");
        });
      ctx.state.loading = false;
    },
    async getHolidays(ctx, payload = {}) {
      const force = !!payload?.force;
      if (!force) {
        if (ctx.state.holidaysLoaded) return;
        if (ctx.state.isFetchingHolidays) return;
      }

      ctx.state.holidayLoading = true;
      ctx.state.isFetchingHolidays = true;
      try {
        const holidays = await api
          .get("/company/holidays")
          .then((res) => res.data.reverse());
        ctx.state.holidays = holidays;
        ctx.state.holidaysLoaded =
          Array.isArray(holidays) && holidays.length > 0;
      } catch (error) {
        console.error("Error fetching holidays:", error);
        ctx.state.holidays = [];
        ctx.state.holidaysLoaded = false;
      } finally {
        ctx.state.holidayLoading = false;
        ctx.state.isFetchingHolidays = false;
      }
    },
    changeHolidayDialog(ctx) {
      ctx.state.holidayDialog = !ctx.state.holidayDialog;
    },
    async addHoliday(ctx, formData) {
      ctx.state.holidayLoading = true;
      try {
        await api.post("/company/holidays", formData).then((res) => {
          ctx.state.addedHolidayId = res.data.id; // Store the ID of the added holiday
        });
        await ctx.dispatch("getHolidays", { force: true }); // Fetch updated holidays
        ctx.state.holidayDialog = false;
        ElMessage.success("Bayram muvaffaqiyatli qo'shildi!");
      } catch (error) {
        console.error("Error adding holiday:", error);
        ElMessage.error("Failed to add holiday");
      } finally {
        ctx.state.holidayLoading = false;
      }
    },
    async deleteHoliday(ctx, id) {
      await api
        .delete(`/company/holidays/${id}`)
        .then(() => {
          ElMessage.success("Bayram muvaffaqiyatli o'chirildi");
          ctx.dispatch("getHolidays", { force: true });
          ctx.state.deleteHolidayDialog = false;
        })
        .catch((error) => {
          ElMessage.error("Bayramni o'chirishda hatolik:" + error);
          console.error("Error deleting holiday:", error);
        });
    },
    changeDeleteHolidayDialog(ctx, holiday = null) {
      ctx.state.deletingHoliday = holiday;
      ctx.state.deleteHolidayDialog = !ctx.state.deleteHolidayDialog;
    },
    changeEditEmployerDialog(ctx, employer = null) {
      ctx.state.editingEmployer = employer;
      ctx.state.editEmployerDialog = !ctx.state.editEmployerDialog;
    },
    async editUserBranches(ctx, data) {
      // Validate data before sending
      if (!data.profile_id) {
        ElMessage.error("Profil ID topilmadi");
        return;
      }

      if (!Array.isArray(data.company_ids)) {
        ElMessage.error("Filiallar ro'yxati noto'g'ri");
        return;
      }

      // Ensure company_ids are numbers
      const companyIds = data.company_ids
        .map((id) => (typeof id === "string" ? parseInt(id) : id))
        .filter((id) => !isNaN(id) && id !== null && id !== undefined);

      const payload = {
        profile_id:
          typeof data.profile_id === "string"
            ? parseInt(data.profile_id)
            : data.profile_id,
        company_ids: companyIds,
      };

      await apiV2
        .put("/users/company/activate", payload)
        .then(() => {
          // Only fetch users if not academy role
          if (!isAcademyRole()) {
            ctx.dispatch("getUsers");
          }
          ElMessage.success("Filiallar o'zgartirildi");
          ctx.state.editEmployerDialog = false;
        })
        .catch((err) => {
          const errorMessage =
            err.response?.data?.message || err.message || "Noma'lum xatolik";
          ElMessage.error(
            `Filiallarni o'zgartirishda xatolik: ${errorMessage}`
          );
        });
    },

    async makeTutor(ctx, { tutor_id, status }) {
      console.log("HR makeTutor called with:", { tutor_id, status });
      await api
        .patch(
          `/users/tutors/${tutor_id}`,
          {},
          {
            params: {
              tutor_id,
              status: status ? 1 : 0,
            },
          }
        )
        .then(() => {
          // Only fetch users if not academy role
          if (!isAcademyRole()) {
            ctx.dispatch("getUsers");
          }
          ElMessage.success("Tutor o'zgardi");
          ctx.state.editEmployerDialog = false;
        })
        .catch((err) => {
          console.error("Error in makeTutor:", err);
          console.error("Error response:", err.response);
          ElMessage.error(
            "Tutor statusini o'zgartirishda xatolik: " +
              (err.response?.data?.message || err.message)
          );
        });
    },
    async getSlots(ctx) {
      ctx.state.slots = await api
        .get("/users/slots_list")
        .then((res) => res.data)
        .catch(() => []);
    },
    async getUserSlots(ctx, user_id) {
      ctx.state.userSlots = await api
        .get("/users/user_slots", {
          params: {
            user_id,
          },
        })
        .then((res) => res.data)
        .catch(() => []);
    },
    async setUserSlots(ctx, data) {
      await api
        .post("/users/user_slots", data)
        .then(() => {
          ElMessage.success("Yangilandi");
          // Only fetch users if not academy role
          if (!isAcademyRole()) {
            ctx.dispatch("getUsers");
          }
          ctx.state.editEmployerDialog = false;
        })
        .catch((err) => {
          console.error("Error in setUserSlots:", err);
          console.error("Error response:", err.response);
          ElMessage.error(
            "Slotlarni o'zgartirishda xatolik: " +
              (err.response?.data?.message || err.message)
          );
        });
    },
    async getPositions(ctx) {
      await api.get("/users/position_tags").then((res) => {
        ctx.state.positions = res.data.map((pos) => pos.title);
      });
    },
    async editEmployer(ctx, data) {
      console.log("HR editEmployer called with data:", data);
      await apiV2
        .put("/users/", data)
        .then(() => {
          ElMessage.success("Yangilandi");
          // Only fetch users if not academy role
          if (!isAcademyRole()) {
            ctx.dispatch("getUsers");
          }
          ctx.state.editEmployerDialog = false;
        })
        .catch((err) => {
          console.error("Error in editEmployer:", err);
          console.error("Error response:", err.response);
          ElMessage.error(
            "Hodim ma'lumotlarini o'zgartirishda xatolik: " +
              (err.response?.data?.message || err.message)
          );
        });
    },
    async updateEmployerAvatar(ctx, { user_id, file }) {
      const fd = new FormData();
      fd.append("file", file);
      try {
        await api.patch(`/me/update_picture?user_id=${user_id}`, fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        ElMessage.success("Avatar yangilandi");
        ctx.state.editEmployerDialog = false;
        if (!isAcademyRole()) {
          ctx.dispatch("getUsers");
        }
      } catch (err) {
        ElMessage.error(
          "Avatarni yuklashda xatolik: " +
            (err.response?.data?.message || err.message)
        );
      }
    },
    async editEmployerGrading(ctx, data) {
      console.log("HR editEmployerGrading called with data:", data);
      await api
        .patch("/users/grade", data)
        .then(() => {
          ElMessage.success("Yangilandi");
          // Only fetch users if not academy role
          if (!isAcademyRole()) {
            ctx.dispatch("getUsers");
          }
          ctx.state.editEmployerDialog = false;
        })
        .catch((err) => {
          console.error("Error in editEmployerGrading:", err);
          console.error("Error response:", err.response);
          ElMessage.error(
            "Gradingni o'zgartirishda xatolik: " +
              (err.response?.data?.message || err.message)
          );
        });
    },
  },
};
